import { ApiTags, rootApi } from "../../../services/rootApi";
import { IIPAdress } from "./IIPAddress";

const TAG = ApiTags.ServiceRequest;

const IPAdressApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getIPAdress: builder.query<IIPAdress, string>({
      query: (IPAddress) => `/IPAddresses/IP/(${IPAddress})`,
      providesTags: (result) => result ? [{ type: TAG, id: result.id }] : [TAG]
    })
  })
})

export const {
  useGetIPAdressQuery,
  useLazyGetIPAdressQuery
} = IPAdressApi;